import { createSlice } from "@reduxjs/toolkit";

const themeSlice = createSlice({
    name: 'theme',
    initialState: {
        dados: {
            theme: 'light'
        },
        status: null
    },
    reducers: {
        setDataTheme: (state, action) => {
            state.dados = action.payload;
        }
    }
});

export const { setDataTheme } = themeSlice.actions;
export default themeSlice.reducer;